import React, { FormEvent } from "react";
import styles from "./AdHayleyBook.module.scss";
import Button from "../button/Button";

type AdHayleyBookProps = {
  isNorthAmerica?: boolean;
};

function AdHayleyBook({ isNorthAmerica = false }: AdHayleyBookProps) {
  const handleOpenMore = () => {
    const link = isNorthAmerica
      ? "https://drive.google.com/file/d/1_-3CHa1zqd-dyFi_RPOHtO266T18PKdj/view?usp=drive_link"
      : "https://drive.google.com/file/d/1_-3CHa1zqd-dyFi_RPOHtO266T18PKdj/view?usp=drive_link";
    
    window.open(link, "_blank");
  };

  return (
    <div className={styles.bodyContainer}>
      <div className={styles.textBody}>
        <div className={styles.highlight}>Featured Highlights</div>
        <h1 className={styles.secondaryTitle}>Online Book Study:</h1>
        <h1 className={styles.title}>
          Helping Students
          <br />
          Reach Their
          <br />
          True Potential
        </h1>
        <p className={styles.description}>
          Register for Dr Hayley’s 2025/2026 <br />
          Book Study sessions
        </p>
        <div className={styles.learnMore}>
          <Button
            size="small"
            color="blue"
            className={styles.learnMoreButton}
            label="Learn More"
            onClick={handleOpenMore}
          />
        </div>
      </div>
    </div>
  );
}

export default AdHayleyBook;
